import { Box, Button, Fab, Grid, Tab, Tabs, tabsClasses, Typography } from "@mui/material"
import CheckIcon from '@mui/icons-material/Check';

import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";

import React, { useEffect, useState } from "react"
import { getAllGroup } from "../features/customerGrouping/customerGroupingApi"

export const Filter = ({ setGetDataPykoad, getDataPayload, groupFilter, categoryFilter,categorySize }) => {
  const [collectionOption, setCollectionOption] = useState([])
  const u1 = [{ label: "Upcoming Birthdays", key: "birthday" }, { label: "Upcoming Anniversaries", key: "Anniversarydate" }]

  useEffect(() => {
    getAllGroup((data) => {
      console.log("groupalldata", data)


      setCollectionOption(data?.data?.list)
    })
  }, [])
  return (
    <React.Fragment>
      <Grid
        container
        alignItems="center"
        sx={{
          zIndex: 0,
        }}
      >
        {/* Upcoming Section */}
        {groupFilter && (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                height: "41px",
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Groups:
              </Typography>
              <Tabs
                key={collectionOption.length}
                value={
                  getDataPayload?.filter === "customerGroup"
                    ? collectionOption.findIndex(
                        (ele) =>
                          ele?.customerGroupName === getDataPayload?.search
                      ) + 1
                    : 0
                }
                onChange={(_, newValue) => {
                  if (newValue === 0) {
                    setGetDataPykoad({
                      ...getDataPayload,
                      filter: "",
                      search: "",
                    });
                  } else {
                    const group = collectionOption[newValue - 1];
                    setGetDataPykoad({
                      ...getDataPayload,
                      filter: "customerGroup",
                      search: group?.customerGroupName,
                    });
                  }
                }}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                indicatorColor="transparent"
                TabIndicatorProps={{ style: { display: "none" } }}
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  mt: 1,
                  [`& .${tabsClasses.scrollButtons}`]: {
                    "&.Mui-disabled": { opacity: 1 },
                    border: "1px solid #9B9B9B",
                    borderRadius: "4px",
                    mx: 1.5,
                    mt: 0.3,
                    backgroundColor: "transparent",
                    height: 30,
                    "& svg": {
                      fontSize: "1.5rem",
                    },
                  },

                  [`& .MuiTab-root`]: {
                    textTransform: "none",
                    backgroundColor: "#fff",
                    color: "#01008B",
                    border: "1px solid #01008B",
                    borderRadius: "20px",
                    marginRight: "8px",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                    height: "30px", // Set tab height to 30px
                    minHeight: "30px", // Ensure minHeight is also 30px
                    maxHeight: "30px", // Optional: restrict maxHeight
                  },
                  [`& .Mui-selected`]: {
                    backgroundColor: "#E2E2FF",
                    fontWeight: 500,
                    boxShadow: "0px 2px 6px rgb(215, 210, 210)",
                  },
                }}
              >
                <Tab
                  sx={{ marginTop: "3px" }}
                  label={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      All
                    </Box>
                  }
                />
                {collectionOption?.map((ele, idx) => (
                  <Tab
                    sx={{ marginTop: "3px" }}
                    key={ele?.customerGroupName || idx}
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        {ele?.customerGroupName}
                      </Box>
                    }
                  />
                ))}
              </Tabs>
            </Box>
          </Grid>
        )}

        {categoryFilter && (
          <Grid
            item
            container
            xs={12}
            spacing={categorySize == 2 ? 6 : 2}
            sx={{
              overflowX: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "nowrap",
              pl: { xs: 2 },
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems:"center"
              }}
              > */}
            {u1?.map((ele, index) => (
              <Grid item xs={categorySize ?? 6}>
                <Button
                  key={index}
                  variant="outlined"
                  onClick={() => {
                    setGetDataPykoad({
                      ...getDataPayload,
                      filter: ele.key,
                      search: "",
                    });
                  }}
                  fullWidth
                  sx={{
                    height: "40px",
                    width: "100%",
                    backgroundColor:
                      getDataPayload?.filter === ele.key ? "#E2E2FF" : "white",
                    border: "1px solid #14008B",
                    borderRadius: "10px",
                    fontSize: { xs: "12px", sm: "13px", md: "14px" },
                    fontWeight: 500,
                    fontFamily: "'Montserrat', sans-serif",
                    padding: "0px",
                    "&:hover": {
                      backgroundColor: "#9B9BF3",
                    },
                  }}
                >
                  {ele.label}
                </Button>
              </Grid>
            ))}
            {/* </Box> */}
          </Grid>
        )}
        {/* <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            marginBottom: "20px",
          }}
        >
          <Typography sx={{ fontWeight: "bold", marginLeft: "12px", marginBottom: "12px" }}>Groups:</Typography>
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}